import * as React from 'react';

function IconNavigationDirectionLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M22 8.5V19H24V8.5C24 7.30653 23.5259 6.16193 22.682 5.31802C21.8381 4.47411 20.6935 4 19.5 4C18.3065 4 17.1619 4.47411 16.318 5.31802C15.4741 6.16193 15 7.30653 15 8.5V23.5C15 24.163 14.7366 24.7989 14.2678 25.2678C13.7989 25.7366 13.163 26 12.5 26C11.837 26 11.2011 25.7366 10.7322 25.2678C10.2634 24.7989 10 24.163 10 23.5V7L12.5 9.5L14 8L9 3L4 8L5.5 9.5L8 7V23.5C8 24.6935 8.47411 25.8381 9.31802 26.682C10.1619 27.5259 11.3065 28 12.5 28C13.6935 28 14.8381 27.5259 15.682 26.682C16.5259 25.8381 17 24.6935 17 23.5V8.5C17 7.83696 17.2634 7.20107 17.7322 6.73223C18.2011 6.26339 18.837 6 19.5 6C20.163 6 20.7989 6.26339 21.2678 6.73223C21.7366 7.20107 22 7.83696 22 8.5Z"
        fill="currentColor"
      />
      <path
        d="M23 29C25.2091 29 27 27.2091 27 25C27 22.7909 25.2091 21 23 21C20.7909 21 19 22.7909 19 25C19 27.2091 20.7909 29 23 29Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconNavigationDirectionLarge;
